"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FONT_WEIGHTS = void 0;
var FONT_WEIGHTS = Object.freeze({
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700
});
exports.FONT_WEIGHTS = FONT_WEIGHTS;
var _default = FONT_WEIGHTS;
exports["default"] = _default;